import React, { FC } from 'react';
import Icon from '../../../@shared/icon';
import Picture from '../../../@shared/picture';
import { ColumnLayoutEnum, TCardImage } from '../../types/cardColumnLayout.types';

const CardImage: FC<TCardImage> = (props) => {
  const { imageOrThumbnail, mobileImageOrThumbnail, isEE, useVideo, showOverlayVideo, id, layout, isWide, triangle } = props;
  if (imageOrThumbnail?.value?.src || mobileImageOrThumbnail?.value?.src || useVideo) {
    return (
      <div
        className={`card__image-wrapper ${useVideo ? 'card__image-wrapper--video' : ''} card__image-wrapper--${layout}`}
        style={{ display: isEE ? 'table' : '' }}
      >
        {triangle?.value && <div className="card__triangle" />}
        {!!useVideo && (
          <div onClick={showOverlayVideo} className="card__play-icon-wrapper">
            <Icon iconName="action-play" extraClassName="card__play-icon" size={isWide ? 32 : 24} />
          </div>
        )}
        {(!!imageOrThumbnail?.value?.src || !!mobileImageOrThumbnail?.value?.src) && (
          <Picture
            editorialImageProps={{
              id: id,
              desktopImage: imageOrThumbnail,
              mobileImage: mobileImageOrThumbnail,
              mobileTransformation: 'Size500',
              desktopTransformation: layout === ColumnLayoutEnum.FourColumnLayout ? 'Size500' : 'Size1000',
              alt: (isWide ? imageOrThumbnail?.value?.alt : mobileImageOrThumbnail?.value?.alt) as string,
              cssClassPictureEl: `card__image card__image--${layout}`,
              isVideoThumbnail: useVideo,
            }}
          />
        )}
      </div>
    );
  }
  return null;
};

export default CardImage;
